module.exports = {
  siteMetadata: {
    title: 'Elohina Guevara',
    author: 'Elohina Guevara',
    description: 'Personal site',
  },
  pathPrefix: '/',
  plugins: [
    {
      resolve: `gatsby-plugin-typography`,
      options: {
        pathToConfigModule: `src/utils/typography.js`,
      },
    },
    {
      resolve: `gatsby-source-filesystem`,
      options: {
        name: `images`,
        path: `${__dirname}/src/assets/images`,
      },
    },
    {
      resolve: `gatsby-plugin-google-fonts`,
      options: {
        fonts: [`Noto Sans JP`, `sans-serif`],
      },
    },
    {
      resolve: `gatsby-transformer-remark`,
      options: {
        plugins: [
          {
            resolve: `gatsby-remark-images`,
            options: {
              maxWidth: 630,
              withWebp: true,
            },
          },
          'gatsby-remark-copy-linked-files',
        ],
      },
    },
    {
      resolve: `gatsby-plugin-manifest`,
      options: {
        name: 'Elohina Guevara',
        short_name: 'Elohina',
        start_url: '/',
        background_color: '#924863',
        theme_color: '#924863',
        display: 'standalone',
        icon: 'src/assets/images/elo.jpg',
        lang: 'en-US',
      },
    },
    `gatsby-plugin-offline`,
    `gatsby-transformer-sharp`,
    `gatsby-plugin-sharp`,
    `gatsby-plugin-react-helmet`,
    `gatsby-plugin-sass`,
  ],
};



// WEBPACK FOOTER //
// ./gatsby-config.js